import script from "./UploadThirdParty.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadThirdParty.vue?vue&type=script&setup=true&lang=js"

import "./UploadThirdParty.vue?vue&type=style&index=0&id=a4cb3a0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4cb3a0c"]])

export default __exports__